<template>
  <div id="editor" @keyup.ctrl.esc="toggleRemarkable">
    <Ace ref="ace" :value="value" @change="onDocumentChanged" @slow-change="saveDocument"></Ace>
    <MarkdownToHtml v-show="remarkableIsVisible" :value="currentValue"></MarkdownToHtml>
    <md-button @click="toggleRemarkable" class="md-fab toggle-remarkable">
      <md-icon v-if="remarkableIsVisible">visibility_off</md-icon>
      <md-icon v-else>visibility</md-icon>
    </md-button>
  </div>
</template>

<script>
  import Vue from 'vue';

  import Ace from './Ace';
  import MarkdownToHtml from './MarkdownToHtml';

  export default {
    name: 'editor',

    data() {
      return {
        /** The file metadata. */
        file: {},

        /** The original value. */
        value: '',

        /** The updated value. */
        currentValue: '',

        remarkableIsVisible: false,

        pendingSave: false,
      };
    },

    components: {
      Ace,
      MarkdownToHtml,
    },

    mounted() {
      this.$events.on('edit-file', (file) => {
        this.file = file;
        const defaultValue = `# ${this.file.name}`;
        if (this.file.id) {
          Vue.googleDrive.fileContent(file.id).then((response) => {
            if (response.status === 200) {
              this.value = response.body || defaultValue;
            } else {
              console.log(response);
            }
          });
        } else {
          this.value = defaultValue;
        }
      });

      this.$events.on('file-delete', (file) => {
        if (this.file.id === file.id || this.file.randomId === file.randomId) {
          if (this.$refs.ace.isReady) {
            this.$refs.ace.destroy();
          }
        }
      });
    },

    methods: {
      onDocumentChanged(value, isFirstChange) {
        this.currentValue = value;
        if (!isFirstChange) {
          this.pendingSave = true;
          this.$events.emit('editor-pending-save', this.file, this.pendingSave, null);
        }
      },

      saveDocument() {
        Vue.googleDrive.saveFile(this.file, this.currentValue).then((response) => {
          if (response.status === 200) {
            this.pendingSave = false;
            // Update id for new file.
            this.file.id = response.result.id;
          }
          this.$events.emit('editor-pending-save', this.file, this.pendingSave, response);
        });
      },

      toggleRemarkable() {
        this.remarkableIsVisible = !this.remarkableIsVisible;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../assets/colors';

  #editor {
    position: relative;
    flex: 1;
    z-index: 1;
  }

  .toggle-remarkable {
    position: absolute;
    bottom: 16px;
    right: 16px;
    z-index: 1001;
  }
</style>


// WEBPACK FOOTER //
// src/components/Editor.vue?ee5a0b0c